export enum PromotionsTypes {
  PERCENT_OFF = 'percent_off',
  AMOUNT_OFF = 'amount_off'
}

export interface IPromotion {
  id: string
  active: boolean
  accountId: string
  orgId: string
  productId?: string
  serviceId?: string
  title: string
  promotionType: PromotionsTypes
  promotionValue: number
  maxRedemptions: number
  createdBy: string
  expiresAt: string
  createdAt: Date
  updatedAt: Date
  note: string | null
  sortBy?: string[]
}

export interface IPromotionFilter {
  orgId?: string
  search?: string
  sortBy?: string[]
  skip?: number
  take?: number
  active?: boolean
}

export interface ICreatePromotion {
  accountId?: string
  orgId?: string
  productId?: string
  serviceId?: string
  title: string
  promotionType: PromotionsTypes
  promotionValue: number
  maxRedemptions: number
  expiresAt: string
  note?: string
}

export interface IApplyPromotion {
  userId: string
  promotionId: string
  maxRedemptions: number
  expiresAt: string
}

export interface IAppliedPromotion {
  id: string
  active: boolean
  userId: string
  walletId: string
  accountId: string
  orgId: string
  productId?: string
  serviceId?: string
  title: string
  promotionType: PromotionsTypes
  promotionValue: number
  maxRedemptions: number
  redemptionCount: number
  expiresAt: string
  createdBy: string
  createdAt: Date
  updatedAt?: Date
  promotionId: string
}

export interface IGetRidersPerPromotion {
  promotionId: string
  active: boolean
  skip?: number
  take?: number
}



// WEBPACK FOOTER //
// ./src/types/promotions.ts